const UpdateSetting = () => {
    document.getElementById('settings-button').onclick = () => {
        document.getElementById('settings-edit-modal___BV_modal_footer_').getElementsByTagName('button')[1].onclick = () => {
            location.reload();
        }
    }
}
export default UpdateSetting;